<template>
    <div>
        <v-btn small color="red" v-if="websocketclientStatus.connected == false" @click="OpenDialog">
            <v-icon color="orange">settings_input_antenna</v-icon>
        </v-btn>
        <v-btn small color="green" v-if="websocketclientStatus.connected == true" @click="OpenDialog">
            <v-icon color="orange">settings_input_antenna</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Connection details</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm6 md4 lg12>
                                <v-text-field v-model="address" label="Address" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4 lg12>
                                <v-text-field v-model="sendMessageString" label="Send test message"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue --darken2" flat @click="SendMessage">Send</v-btn>
                    <v-btn color="success" flat @click="dialog = false">Save</v-btn>
                    <v-btn color="grey" flat @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import EventBus from '@/libs/event-bus/event-bus.js';
    import websocket from '@/libs/sockets/websocket.js'

    export default {
        data: () => ({
            dialog: false,
            address: 'ws://localhost:9700',
            websocketclient: null,
            websocketclientStatus: {
                connected: false,
                message: null
            },
            sendMessageString: "",
            reconnectIntervalVar: null
        }),

        beforeDestroy() {
            let self = this;
            self.websocketclient.disconnect();
            EventBus.$off('WS_STATUS', self.websocket_status_handler);
            clearInterval(self.reconnectIntervalVar);
        },
        created() {
            var self = this;
            // get settings find server address and then connect
            self.websocketclient = new websocket.WebSocketClient(self.address)
            self.websocketclient.connect();
            EventBus.$on('WS_STATUS', this.websocket_status_handler);
            self.reconnectIntervalVar = setInterval(self.Reconnect, 5000);
        },
        methods: {
            websocket_status_handler(status) {
                var self = this
                self.websocketclientStatus = status
            },
            SendWS() {
                var self = this
                EventBus.$emit('WS_SEND_MESSAGE', JSON.stringify({
                    imAlive: true,
                    message: 'sample message send',
                    application: "DisplayManager"
                }));
            },
            OpenDialog() {
                let self = this;
                self.dialog = !self.dialog;
            },
            SendMessage() {
                let self = this;
                self.websocketclient.send(self.sendMessageString);
            },
            Reconnect() {
                let self = this;
                if (self.websocketclient.getStatus() >= 2) {
                    self.websocketclient.reconnect(self.address)
                }
            }
        }
    }
</script>

<style>

</style>